module.exports = {
	"config": {
		"siteTitle": "Erdal Mutlu -- Home Page",
		"siteDescr": "Hi. I'm a recent Ph.D. graduate from Koç University where I worked on Software Reliability.\t",
		"siteAuthor": "Erdal Mutlu",
		"siteTwitterUrl": "https://twitter.com/erdalmutlu",
		"siteGithubUrl": "https://github.com/erdalmutlu",
		"siteEmailUrl": "erdalmutlu.su@gmail.com",
		"googleAnalyticsId": "",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages\\about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages\\about\\index.md",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\pages\\about\\index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages\\contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages\\contact\\index.md",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\pages\\contact\\index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages\\education",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/education",
				"stem": "index",
				"path": "pages\\education\\index.md",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\pages\\education\\index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/education/index.md",
			"path": "/education/",
			"data": {
				"title": "Education",
				"layout": "page",
				"path": "/education"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages\\projects",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/projects",
				"stem": "index",
				"path": "pages\\projects\\index.md",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\pages\\projects\\index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/projects/index.md",
			"path": "/projects/",
			"data": {
				"title": "Projects",
				"layout": "page",
				"path": "/projects"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages\\publications",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/publications",
				"stem": "index",
				"path": "pages\\publications\\index.md",
				"absolute": "C:\\Users\\Erdal\\Desktop\\Git_Projects\\personal-site\\pages\\publications\\index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/publications/index.md",
			"path": "/publications/",
			"data": {
				"title": "Publications",
				"layout": "page",
				"path": "/publications"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 375
// module chunks = 0